import React from 'react'

import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'

import Typography from 'components/atoms/Typography'
import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'

import { string, arrayOf } from 'prop-types'

import config from 'config'

const { assets_url: assetsUrl } = config

const MajorSkills = ({ skills, imgSrc, imgAlt }) => (
  <div id="skills" className="major-skills">
    <div className="major-skills__bg"/>
    <SectionContainer
      className="major-skills__content"
      paddingTop={80}
      paddingBottom={120}
      backgroundColor="transparent"
    >
      <Container>
        <Row>
          <Col md="7">
            <SectionTitle title="Pengetahuan dan Keahlian" align="left" />
            <ul>
              {
                skills.map((skill, idx) => (
                  <li key={`skill-${idx}`}>
                    <Typography component="p" variant="headline">{ skill }</Typography>
                  </li>
                ))
              }
            </ul>
          </Col>
          <Col md="5">
            <img className="major-skills__img major-skills__img--no-mobile" src={imgSrc} alt={imgAlt}/>
          </Col>
        </Row>
      </Container>
    </SectionContainer>
    <div className="clip-background"/>
    <style jsx>
      {`
        .major-skills {
          position: relative;
          overflow: hidden;
          &__bg {
            background-color: #f6f7fa;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            transform: skewY(-10deg);
            transform-origin: top left;
          }
          :global(&__content) {
            position: relative;
            @media screen and (min-width: 768px) {
              background-image: url(${assetsUrl}/assets/img/major_detail/rectangle-element.svg);
              background-position: top 30% right 0;
              background-repeat: no-repeat;
            }
          }
          &__img {
            width: 100%;
            border-radius: 8px;
          }
          &__img--no-mobile {
            display: none;
            @media screen and (min-width: 768px) {
              display: unset;
            }
          }
        }
        ul {
          padding-left: 24px;
          li {
            margin-bottom: 8px;
          }
        }
      `}
    </style>
  </div>
)

MajorSkills.propTypes = {
  skills: arrayOf(string),
  imgSrc: string,
  imgAlt: string,
}

export default MajorSkills
